import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthSsoService } from './auth-sso.service';
import { ssoConfig } from './sso.config';

// Entrada do RM (/, /login, /sso-login) e retorno do SSO (/callback). Quando o retorno da certo, o AuthSsoService
// ja troca a URL pela rota salva antes do router comecar; esta tela so aparece no caminho ou num erro.
@Component({
  selector: 'app-sso-login',
  template: `
    <div class="sso-login">
      <h2 *ngIf="!error">Redirecionando para autenticação SSO...</h2>
      <ng-container *ngIf="error">
        <h2>{{ error }}</h2>
        <div class="sso-login__actions">
          <button type="button" class="sso-login__retry" (click)="retry()">Entrar novamente</button>
          <a class="sso-login__portal" [href]="portalUrl">Ir para aplicativos</a>
        </div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      .sso-login {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;
        height: 100vh;
        text-align: center;
        padding: 0 16px;
      }
      .sso-login__actions {
        display: flex;
        gap: 16px;
        align-items: center;
      }
      .sso-login__retry {
        background: #17aa5d;
        color: #ffffff;
        border: 0;
        border-radius: 4px;
        padding: 8px 16px;
        cursor: pointer;
      }
      .sso-login__portal {
        color: #17aa5d;
      }
    `
  ]
})
export class SsoLoginComponent implements OnInit {
  error: string = null;
  readonly portalUrl = ssoConfig.issuer;

  constructor(private authSso: AuthSsoService, private router: Router) {}

  ngOnInit(): void {
    this.authSso.initialize().then(() => {
      // Ja ha sessao nesta aba (ex.: veio pelo card do portal com o RM aberto): segue para a rota salva.
      // Um ticket sem id_token e de outra aba ou de uma sessao antiga (localStorage): esse passa pelo SSO.
      if (this.authSso.hasSsoSession() && this.authSso.getAlfrescoTicket()) {
        this.router.navigateByUrl(this.authSso.consumeSavedRoute());
        return;
      }
      // Retorno do SSO que falhou: mostra o erro em vez de mandar de novo para o SSO (seria um ciclo).
      if (this.authSso.lastError) {
        this.error = this.authSso.lastError;
        return;
      }
      if (!this.authSso.login()) {
        this.error = this.authSso.lastError;
      }
    });
  }

  retry(): void {
    this.error = null;
    if (!this.authSso.retryLogin()) {
      this.error = this.authSso.lastError;
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/sso/sso-login.component.ts